export default __webpack_public_path__ + "static/media/bgBackgroundPuspenerbalMap.c02731b7.png";